import axios from 'axios'

// Global Axios Configuration.
export default axios.create({
  baseURL: '/api',
  headers: {
    'Content-Type': 'application/json'
  }
})
